const useMovieActiveWatching = (data, idMovie) => {
	let filteredActiveWotching = []
	if (data) {
		let filterDate = false
		data.filter(([key, value]) => {
			if (value.contentID === idMovie) {
				if (!filterDate) {
					filterDate = value.date
					filteredActiveWotching = [key, value]
					return false
				}
				if (value.date > filterDate) {
					filterDate = value.date
					filteredActiveWotching = [key, value]
				}
			}
		})
	}
	return filteredActiveWotching
}

export default useMovieActiveWatching;